export enum ExpireConfigUnitType {
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}

export enum CancelStrategyType {
  WHEN_RENTED = 'WHEN_RENTED',
  MAX_INTENT_DECLARATIONS = 'MAX_INTENT_DECLARATIONS'
}

export enum AutoDeactivateType {
  PUBLISHED_DAYS = 'PUBLISHED_DAYS',
  APPLICATIONS = 'APPLICATIONS'
}

/**
 * Application channels an applicant can reach a property through. Used to
 * restrict which applicants the automated workflow invites to a viewing.
 */
export type ApplicationChannelType =
  | 'HOMEPAGE'
  | 'EXTERNAL_PORTAL'
  | 'IMMOMIO_PORTAL'
  | 'RESIDENT_APP'
  | 'TENANT_POOL';

export const APPLICATION_CHANNEL_OPTIONS: {
  name: string;
  value: ApplicationChannelType;
}[] = [
  {
    name: 'automated_rental.auto_invite.application_channel.homepage_l',
    value: 'HOMEPAGE'
  },
  {
    name: 'automated_rental.auto_invite.application_channel.external_portal_l',
    value: 'EXTERNAL_PORTAL'
  },
  {
    name: 'automated_rental.auto_invite.application_channel.immomio_portal_l',
    value: 'IMMOMIO_PORTAL'
  },
  {
    name: 'automated_rental.auto_invite.application_channel.resident_app_l',
    value: 'RESIDENT_APP'
  },
  {
    name: 'automated_rental.auto_invite.application_channel.tenant_pool_l',
    value: 'TENANT_POOL'
  }
];
